<template>
    <modal v-model="show">
        <slot />

        <form
            v-if="!form.wasSuccessful"
            @submit.prevent="subscribe"
            :action="urls.subscribers_store"
            method="post"
            class="space-y-4"
        >
            <div class="p-4 text-center text-xl font-semibold bg-gray-100 rounded text-gray-700">Subscribe to get a free weekly email about the latest SQL jobs.</div>

            <text-input
                label="Email"
                placeholder="Email"
                v-model="form.email"
                :error="form.errors.email"
            />
        </form>

        <div v-else class="notification success">
            You'll now receive a weekly email of the latest SQL Jobs.
        </div>

        <template #footer="{ close }">
            <div class="flex gap-4">
                <button
                    @click.prevent="close"
                    class="flex-1 px-4 py-2 rounded border-2 border-sky-500 hover:bg-sky-500 tracking-wide font-semibold text-gray-800 hover:border-transparent hover:text-gray-100"
                >
                    Close
                </button>

                <loading-button
                    v-if="!form.wasSuccessful"
                    @click.prevent="subscribe"
                    :loading="form.processing"
                    class="btn btn-green flex-1 "
                >
                    Subscribe
                </loading-button>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import axios from 'axios';
import useForm from '@/functions/useForm'
import { trackEvent } from "../functions/googleAnalytics";

const props = defineProps({
    urls: {
        type: Object,
        required: true,
    }
})

const show = ref(false)

const form = useForm({
    email: ''
})

const subscribe = () => form.post(props.urls.subscriber_store, {
    onSuccess: () => {
        form.reset()
        trackEvent('subscribe')
    }
})

watch(
show,
async value => {
    if(value) return
    await axios.delete(props.urls.ad_modal_destroy)
})

onMounted(() => {
    setTimeout(() => {
        show.value = true
    }, 10000);
})
</script>
